import { render } from "./SVGSeparator.vue?vue&type=template&id=6d61da75"
import script from "./SVGSeparator.vue?vue&type=script&lang=js"
export * from "./SVGSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__